import React from "react";
import { styled } from "@mui/system";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box } from "@mui/material";

const Heading = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(15),
  fontWeight: theme.typography.fontWeightRegular,
}));

export function PriceSheetCreateDoc() {
  return (
    <Box sx={{ width: "50%", marginLeft: "2em" }}>
      <h2>More Info</h2>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
          <Heading>Price Sheet Code</Heading>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <p>
              This code will be what is referenced in the account contract and represent the list of prices per product
              that correspond to the products.
            </p>
            <ul>
              <li>
                This <b>CANNOT</b> be altered later
              </li>
            </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
          <Heading>Description</Heading>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <p>This is the description of the price sheet</p>
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}

export function PriceSheetItemCreateDoc() {
  return (
    <Box sx={{ width: "50%", marginLeft: "2em" }}>
      <h2>More Info</h2>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
          <Heading>Price Sheet Code</Heading>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <p>This is the code of the price sheet this item will belong to.</p>
            <ul>
              <li>
                This <b>CANNOT</b> be altered later
              </li>
            </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
          <Heading>Product Code</Heading>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <p>This is the product code for the product to be used.</p>
            <ul>
              <li>The code entered here must match a real product code in the database.</li>
            </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
          <Heading>Price</Heading>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <p>This is the price for the product</p>
            <ul>
              <li>
                Please Note: The amount here <b>MUST</b> be in{" "}
                <b>
                  <u>cents</u>
                </b>
                .
              </li>
              <li>
                This <b>CANNOT</b> be altered later
              </li>
            </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
          <Heading>Free Quantity</Heading>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <p>This is the quantity of free items allowed in each billing period.</p>
            <p>
              For example: as a standard offering we give 10,000 free Trip Planner API requests per month to each
              customer.
            </p>
            <ul>
              <li>
                This <b>CANNOT</b> be altered later
              </li>
            </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
